export const pascalCaseToString = (value: string): string => {
  if (!value) {
    return "";
  }

  const wordRe = /($[a-z])|[A-Z][^A-Z]+/g;
  const text: string = value.match(wordRe)?.join(" ") || "";

  return text ? `${text.charAt(0)}${text.slice(1, text.length).toLowerCase()}` : "";
};

export const cleanValue = (value: string) => {
  return value.replaceAll("--start--", "").replaceAll("--end--", "").replaceAll(" ,", "");
};
